export const productUploader = (data) => {
  const formdata = new FormData();

  formdata.append('name', data.name);
  formdata.append('item_code', data.item_code);
  formdata.append('category_id', data.category_id != null ? data.category_id : '');
  formdata.append('regular_price', data.original_price != null ? data.original_price : '');
  formdata.append('discount_type', data.discount_type || 'none');
  formdata.append('discount_value', data.discount_value != null ? data.discount_value : '');
  formdata.append('discount_start_date', data.discount_start_date || '');
  formdata.append('discount_end_date', data.discount_end_date || '');
  formdata.append('stock_quantity', data.stock_quantity != null ? data.stock_quantity : '');
  formdata.append('min_quantity', data.min_quantity != null ? data.min_quantity : '');
  formdata.append('max_quantity', data.max_quantity != null ? data.max_quantity : '');
  formdata.append('stock_unit_id', data.stock_unit_id || null);
  formdata.append('product_type', data.product_type || 'daily');
  formdata.append('status', data.enabled);

  
  if (data.image && data.image.length > 0) {
   formdata.append('image',  data.image[0] );
  }

  if (data.image_removed !== undefined) {
    formdata.append('image_removed', data.image_removed === true || data.image_removed === 'true' || data.image_removed === 1 || data.image_removed === '1' ? '1' : '0');
  }

  return formdata;
}
